import { useAuthInfo } from '@propelauth/react';
import { useEffect, useState } from 'react';
import FullScreenMessage from '../components/FullScreenMessage';
import { sydonAuthApi } from '../services/sydonApi';
import LoginGate from './LoginGate';

type CallbackState = 'waiting' | 'validating' | 'error';

export default function AuthCallback(): JSX.Element {
  const { loading, accessToken } = useAuthInfo();
  const [state, setState] = useState<CallbackState>('waiting');
  const [validatedToken, setValidatedToken] = useState<string | null>(null);

  useEffect(() => {
    if (loading) return;
    if (!accessToken) {
      setState('error');
      return;
    }
    if (validatedToken === accessToken) return;

    setState('validating');
    sydonAuthApi
      .validate(accessToken)
      .then(() => {
        setValidatedToken(accessToken);
        window.location.replace('/');
      })
      .catch(() => setState('error'));
  }, [loading, accessToken, validatedToken]);

  if (state === 'error') {
    return <LoginGate text="Sign-in failed. Please try again." />;
  }
  return (
    <FullScreenMessage
      text={state === 'validating' ? 'Confirming your session…' : 'Signing you in…'}
    />
  );
}
